import { AbstractCommand } from 'src/models/command';

class UnLinkTheAggregateFromTheIdo extends AbstractCommand {
	readonly name = 'IFS_IDO_Command_Command_UnLinkTheAggregateFromTheIdo';

	public constructor(aggregateId: string, idoId: number, idoInstanceId: number) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
			idoId: idoId,
			idoInstanceId: idoInstanceId,
		};
	}
}

export { UnLinkTheAggregateFromTheIdo };
